import { type FC, type ReactNode, type CSSProperties } from "react";
import clsx from "clsx";

type Variant = "outlined" | "filled";
type Width = "small" | "medium" | "large" | "custom";
type Height = "small" | "medium" | "large" | "custom";

interface GxButtonProps {
  variant?: Variant;
  children: ReactNode;
  onClick?: () => void;
  bgColor?: string;
  textColor?: string;
  disabled?: boolean;
  width?: Width;
  customWidth?: string;
  height?: Height;
  customHeight?: string;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const GxButton: FC<GxButtonProps> = ({
  variant = "outlined",
  children,
  onClick,
  bgColor,
  textColor,
  disabled = false,
  width = "medium",
  customWidth,
  height = "medium",
  customHeight,
  className,
  type = "button",
}) => {
  const widthClass =
    width === "small"
      ? "gx-btn-w-small"
      : width === "medium"
      ? "gx-btn-w-medium"
      : width === "large"
      ? "gx-btn-w-large"
      : "";

  const heightClass =
    height === "small"
      ? "gx-btn-h-small"
      : height === "medium"
      ? "gx-btn-h-medium"
      : height === "large"
      ? "gx-btn-h-large"
      : "";

  const inlineStyle: CSSProperties = {};

  if (variant === "outlined") {
    if (bgColor) {
      inlineStyle.borderColor = bgColor;
      inlineStyle.color = bgColor;
    }
  } else {
    if (bgColor) inlineStyle.backgroundColor = bgColor;
    if (textColor) inlineStyle.color = textColor;
  }

  if (customWidth) inlineStyle.width = customWidth;
  if (customHeight) inlineStyle.height = customHeight;

  return (
    <button
      type={type}
      className={clsx(
        "gx-button",
        "gx-p14-sb",
        variant === "outlined" ? "gx-btn-outlined" : "gx-btn-filled",
        widthClass,
        heightClass,
        disabled && "gx-disabled",
        className
      )}
      style={inlineStyle}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default GxButton;